// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"b7837a82","427":"0da56b82","560":"e0d33f3b"}[chunkId] + ".chunk.js";
};